import React from "react"

export default function Footer() {
  return (
    <footer className="mt-16 border-t bg-white">
      <div className="max-w-7xl mx-auto px-4 py-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        <div>
          <div className="text-xl font-extrabold mb-2">QuipusMania</div>
          <p className="text-sm text-gray-600">
            Comparador de precios y guía de comercios cercanos.
          </p>
        </div>
        <div>
          <div className="font-semibold mb-2">Contacto</div>
          <ul className="space-y-1 text-sm text-gray-700">
            <li>
              Email:{" "}
              <a className="underline" href="mailto:contacto@quipusmania.com">
                contacto@quipusmania.com
              </a>
            </li>
            <li>
              <div className="flex items-center space-x-4 mt-2">
                <a
                  href="https://instagram.com/quipusmania"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:opacity-80 transition-opacity"
                  title="Síguenos en Instagram"
                >
                  <img
                    src="/icons/instagram.png"
                    alt="Instagram"
                    className="w-6 h-6"
                  />
                </a>

                <a
                  href="https://facebook.com/quipusmania"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:opacity-80 transition-opacity"
                  title="Síguenos en Facebook"
                >
                  <img
                    src="/icons/facebook.png"
                    alt="Facebook"
                    className="w-6 h-6"
                  />
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-2">Legal</div>
          <ul className="space-y-1 text-sm text-gray-700">
            <li>
              <a href="/terminos" className="underline">
                Términos y condiciones
              </a>
            </li>
            <li>
              <a href="/privacidad" className="underline">
                Política de privacidad
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="text-center text-xs text-gray-500 pb-6">
        © {new Date().getFullYear()} QuipusMania
      </div>
    </footer>
  )
}
